import React from 'react';
import { Section } from './ui/Section';
export function HowItWorks() {
  const steps = [{
    num: '1',
    title: 'Día 1: Diagnóstico',
    desc: 'Espejo + foto/worksheet.'
  }, {
    num: '2',
    title: 'Diarios',
    desc: '12min movimientos post-leche + swaps comidas + checklist.'
  }, {
    num: '3',
    title: 'Semanal',
    desc: 'Foto día 7/14/21 + medida cintura.'
  }];
  return <Section className="bg-[#FFF8F0]" data-id="element-71">
      <h2 className="text-3xl md:text-4xl font-bold text-[#0D5C63] mb-16 text-center font-serif" data-id="element-72">
        Cómo Funciona
      </h2>

      <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-73">
        {/* Connector Line (Desktop) */}
        <div className="hidden md:block absolute top-10 left-0 w-full h-0.5 bg-[#C9A84C]/30 -z-10 transform translate-y-4" data-id="element-74"></div>

        {steps.map((step, index) => <div key={index} className="text-center relative bg-[#FFF8F0] md:bg-transparent p-4" data-id="element-75">
            <div className="w-20 h-20 bg-[#C9A84C] text-[#2D2D2D] rounded-full flex items-center justify-center text-3xl font-bold mx-auto mb-6 shadow-lg border-4 border-white" data-id="element-76">
              {step.num}
            </div>
            <h3 className="text-xl font-bold text-[#0D5C63] mb-2 font-serif" data-id="element-77">
              {step.title}
            </h3>
            <p className="text-gray-600" data-id="element-78">{step.desc}</p>
          </div>)}
      </div>
    </Section>;
}